export const LANGUAGES: any = {
  DE: 'common.labels.german',
  EN: 'common.labels.english'
};

export const OBSERVERTYPES: any = {
  active: 'common.labels.observer',
  silent: 'common.labels.silent_observer'
};

export const EXERCISEPART_RATING_START_OPTIONS: any = {
  none: 'common.labels.ratingstart_none',
  start: 'common.labels.ratingstart_start',
  end: 'common.labels.ratingstart_end',
};

export const SALUTATIONS: any = {
  female: 'common.labels.mrs',
  male: 'common.labels.mr',
  'no-binary': 'common.labels.no-binary',
  undeclared: 'common.labels.undeclared'
};

export const GENDERS: any = {
  female: 'common.labels.female',
  male: 'common.labels.male',
  'no-binary': 'common.labels.no-binary',
  undeclared: 'common.labels.undeclared'
};

export const YESNO: any = {
  yes: 'common.labels.yes',
  no: 'common.labels.no'
};

export const ROLE_NAMES = {
  administrator: 'common.labels.administrator',
  dispatcher: 'common.labels.dispatcher',
  moderator: 'common.labels.moderator',
  observer: 'common.labels.observer',
  orderer: 'common.labels.orderer',
  moderator_external: 'common.labels.moderator_external',
  observer_gem: 'common.labels.observer_gem',
  hiringmanager: 'common.labels.hiringmanager',
  workers_council: 'common.labels.workers_council',
  disabled_persons_representative: 'common.labels.disabled_persons_representative',
  hr_businesspartner: 'common.labels.hr_businesspartner',
  executive_contact: 'common.labels.executive_contact',
  other: 'common.labels.other',
};

export const STATUS_NAMES = {
  requested: 'common.labels.requested',
  planned: 'common.labels.planned',
  running: 'common.labels.running',
  finished: 'common.labels.finished',
  cancelled: 'common.labels.cancelled',
};

export const ORDER_DOCUMENT_TYPES = {
  curriculum_vitae: 'common.labels.curriculum_vitae',
  announcement: 'common.labels.announcement',
  man_report: 'common.labels.man_report',
  test: 'common.labels.test',
  order: 'common.labels.order',
  job_description: 'common.labels.job_description',
  others: 'common.labels.others',
};

export const ELEMENT_TYPES = {
  html: 'common.labels.html-file'
};

export const TEXT_TYPES = {
  text: 'common.labels.text',
  mail: 'common.labels.mail',
  sms: 'common.labels.sms',
};

export const ONLINETEST_TYPE_NAMES = {
  before: 'common.labels.before',
  normal: 'common.labels.during_ac',
};

export const OBSERVER_OPENABLE_TIMEOUT = 6 * 60; // minutes

export const PRIORTIES_2: any = {
  1: 1,
  2: 2,
};

export const PRIORTIES_6: any = {
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
};

export const CANCELLATION_REASONS = {
  customer: 'common.labels.customer',
  moderator: 'common.labels.moderator',
  observer: 'common.labels.observer',
  observer_gem: 'common.labels.observer_gem',
  others: 'common.labels.others',
};

export const UPLOAD_MODE_MULTI = true;
